import React from 'react';
import Button from '../Button';
import { GroupDropdown } from './ButtonGroup.styled';

const tooltipId = 'tooltip_toolbar';

type ButtonWithDropdownProps = {
  icon?: string;
  viewBox?: string;
  tooltip?: string;
  items?: any[];
  onClick: () => void;
  hasDropdown?: boolean;
  dropdownContent?: React.ReactNode;
  customColor?: string;
  dataIntercomTarget?: any;
  isDisabled?: boolean;
  isActive?: boolean;
  isVisible?: boolean;
  dropdownDirection?: string;
  renderIcon?: (isHover?: boolean) => any;
  transparent?: boolean;
  groupDropdownProps?: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >;
} & Record<string, any>;

export const ButtonWithDropdown = ({
  icon,
  viewBox = '0 0 24 24',
  tooltip,
  items,
  onClick,
  isActive,
  isVisible,
  hasDropdown,
  dropdownContent,
  customColor,
  groupDropdownProps = {},
  dataIntercomTarget,
  isDisabled = false,
  dropdownDirection = 'right',
  renderIcon,
  transparent,
  ...restButtonProps
}: ButtonWithDropdownProps) => {
  return (
    <>
      {dropdownContent && isActive && (
        <GroupDropdown
          dropdownDirection={dropdownDirection}
          {...groupDropdownProps}
        >
          {dropdownContent}
        </GroupDropdown>
      )}
      <Button
        icon={icon}
        iconViewBox={viewBox}
        items={items}
        appearance='plain'
        variant='tertiary'
        size='default'
        data-for={tooltipId}
        data-tip={tooltip}
        data-tip-disable={dropdownContent && isActive}
        onClick={onClick}
        isActive={isActive}
        isVisible={isVisible}
        customColor={customColor}
        hasDropdown={hasDropdown}
        isDisabled={isDisabled}
        data-intercom-target={dataIntercomTarget}
        transparent={transparent}
        renderIcon={renderIcon}
        {...restButtonProps}
      />
    </>
  );
};
